import { render } from "./Carrusel-Component-2_ingles.vue?vue&type=template&id=11df3780&scoped=true"
import script from "./Carrusel-Component-2_ingles.vue?vue&type=script&lang=js"
export * from "./Carrusel-Component-2_ingles.vue?vue&type=script&lang=js"

import "./Carrusel-Component-2_ingles.vue?vue&type=style&index=0&id=11df3780&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11df3780"]])

export default __exports__